import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    labelFormValue : {
      textAlign: "left",
      fontFamily: "Poppins, sans-serif",
      fontStyle: "normal",
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '19px',
      alignItems: "center",
      order: 1,
      flexGrow: '0',
      margin: '0px 8px',
      padding: '0.5em',
      background: '#009EE2B2',
      borderRadius: '0.5em',
      color: '#fff',
      wordBreak: "break-word",
      width: '50%',
    },
    title : {
      fontFamily: "Roboto, sans-serif",
      fontStyle: "normal",
      fontWeight: '500',
      fontSize: '18px',
      lineHeight: '21.09px',
    },
    secundary : {
      fontFamily: "Roboto, sans-serif",
      fontStyle: "normal",
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '18.75px',
    },
    formDataPlaceholder : {
      background: "#182444",
      width: "100%",
      border: "1px solid #286796",
      borderRadius: '1em',
      padding: "1em",
      margin: "1em 0",
    },
    formContent : {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
      margin: "0.5em 0em 0.5em 0em",
    },
    labelFormProperty : {
      textAlign: "left",
      fontFamily: "Poppins, sans-serif",
      fontWeight: '400',
      fontSize: '13px',
      wordBreak: "break-word",
      width: "50%",
    },
    downloadButton : {
      width:'40px', 
      height:'40px', 
      background: '#222736', 
      display: 'flex', 
      borderRadius: '1em', 
      padding: '0.5em', 
      position: 'absolute',
      right:0,
      margin:'1em 2em 0 0',
      zIndex: 1,
      justifyContent: 'center', 
      opacity: '80%',
      transition: 'transform 1s, opacity 0.5s',
      transitionTimingFunction: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
      '&:hover':{
        transform: 'scale(1.5)',
        cursor: 'pointer',
        color: '#556ee6 !important',
        opacity: '90%',
      }
    }
    
  }))

export default useStyles
